import CitySEOHead from "@/components/feature/CitySEOHead";
import DavenportHeroSection from "./components/HeroSection";
import DavenportStickyNav from "./components/StickyNav";
import DavenportProcessingTimeSection from "./components/ProcessingTimeSection";
import DavenportServicesSection from "./components/ServicesSection";
import DavenportLocalAreaSection from "./components/LocalAreaSection";
import DavenportTestimonialsSection from "./components/TestimonialsSection";
import DavenportAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DavenportComparisonSection from "./components/ComparisonSection";
import DavenportMistakesSection from "./components/MistakesSection";
import DavenportHowItWorksSection from "./components/HowItWorksSection";
import DavenportFAQSection, { faqs } from "./components/FAQSection";
import DavenportHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DavenportFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function DavenportPage() {
  return (
    <>
      <CitySEOHead
        city="Davenport"
        state="Iowa"
        stateAbbr="IA"
        route="/cities/davenport"
        title="Emergency Passport Davenport, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Davenport, IA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Scott County and Quad Cities travelers."
        geoPlacename="Davenport, Iowa"
        geoPosition="41.5236;-90.5776"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
        keywords="expedited passport, emergency passport, Davenport passport, same day passport Davenport, fast passport Iowa, Quad Cities passport, Scott County passport"
      />
      <div className="font-sans">
        <DavenportHeroSection />
        <DavenportStickyNav />
        <DavenportProcessingTimeSection />
        <DavenportLocalAreaSection />
        <DavenportServicesSection />
        <DavenportTestimonialsSection />
        <DavenportAcceptanceFacilitiesSection />
        <DavenportComparisonSection />
        <DavenportMistakesSection />
        <DavenportHowItWorksSection />
        <DavenportFAQSection />
        <DavenportHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/davenport" state="IA" />
        <DavenportFinalCTA />
      </div>
    </>
  );
}